// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_a5-3";
export var contentContainer = "_a5-0";
export var editorContainer = "_a5-1";
export var quillInputForm = "_a5-2";
export var zoneDivider = "_a5-4";